import { AccountType } from '@seapoint/server/enums';
import { AccountInvestmentTypeView, AccountView } from '../../types/entity-types';

export const isInvestmentAccount = (account: AccountView): account is AccountInvestmentTypeView => {
  return account.type === AccountType.INVESTMENT;
};
